module.exports = __webpack_public_path__ + "af8656993f27a0bd608d9aab07fca37f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/phone-numbers/confirm-remove-recovery/confirm-remove-recovery.html
// module id = 2527
// module chunks = 0